import { useEffect, useState } from "react";

export const useDebounce = (value: any = null, delay: number = 500) => {
    const [debouncedValue, setDebouncedValue] = useState<any>(value);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => clearTimeout(timeout);
    }, [value, delay])

    return debouncedValue;
}